// vms-tv-pages.js: the lookup box on the TV series, brand and hub pages. Notes: assets/vms-tv-pages.notes.md
(function (root) {
  'use strict';
  var FIND = 'See every mount that fits this TV';

  function norm(x) { return String(x == null ? '' : x).toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function size(v) { var n = typeof v === 'number' ? v : NaN; return isFinite(n) && n > 0 ? Math.round(n) : null; }
  function findHref(base, row) {
    var z = size(row.screen_size_in);
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'tvm=' + encodeURIComponent(row.model_number) + (z != null ? '&size=' + z : '');
  }

  function pick(d, data) {
    var n = norm(d.model_norm || d.model_number), row = data.rows && data.rows[n], other = data.map && data.map[n];
    var out = { kind: 'none', id: null, size: null, href: null, text: null };
    if (row) {
      out.kind = 'row'; out.id = row.id; out.size = row.chip != null ? row.chip : (typeof row.size === 'number' ? row.size : null);
      if (row.lb != null || row.find) out.sel = { lb: row.lb != null ? row.lb : null, find: row.find || null };
    }
    else if (other) { out.kind = 'other'; out.href = other.u; out.text = 'See every mount for the ' + other.n; return out; }
    if (d.lookup_status === 'vesa_known' && d.model_number != null && d.model_number !== '') { if (out.kind === 'none') out.kind = 'find'; out.href = findHref(data.find, d); out.text = FIND; }
    return out;
  }

  function arrival(search, saved, data) {
    var m = /[?&]tvm=([^&#]*)/.exec(search || ''), t = m ? decodeURIComponent(m[1].replace(/\+/g, ' ')).trim() : '';
    if (t && t.length <= 64) return { term: t };
    if (data.scope === 'hub' || !saved || saved.source !== 'catalog' || !saved.row) return null;
    var r = saved.row, ok = data.scope === 'brand' ? norm(data.brand) !== '' && norm(r.manufacturer) === norm(data.brand) : !!(data.rows && data.rows[norm(r.model_norm || r.model_number)]);
    return ok ? { row: r, catalog_version: saved.catalog_version } : null;
  }

  function reserveOn(value, hasCard) {
    if (String(value == null ? '' : value).trim().length >= 2) return true;
    return hasCard ? null : false;
  }

  function Box(el) {
    var self = this;
    this.el = el;
    try { this.data = JSON.parse(el.querySelector('[data-tvp-data]').textContent); } catch (e) { this.data = { rows: {}, map: {}, find: '/pages/find-mounts-by-tv-model', scope: 'hub' }; }
    this.page = el.closest('[data-vms-tvp]') || document;
    this.jump = false;
    el.addEventListener('vms:tv-selected', function (e) { self.selected(e.detail || {}); });
    el.addEventListener('vms:tv-cleared', function () { self.jump = false; self.mark(null); el.removeAttribute('data-tvp-reserve'); });
    el.addEventListener('input', function (e) {
      self.jump = false;
      var t = e.target, on = t && t.matches && t.matches('[data-tvl-input]') ? reserveOn(t.value, !!el.querySelector('.vms-tvl__card')) : null;
      if (on === true) el.setAttribute('data-tvp-reserve', ''); else if (on === false) el.removeAttribute('data-tvp-reserve');
    });
    el.addEventListener('submit', function () { el.setAttribute('data-tvp-reserve', ''); });
    this.widget(function (w) { self.arrive(w); });
  }
  Box.prototype.widget = function (cb, tries) {
    var r = this.el.querySelector('[data-vms-tvl]'), self = this;
    if (r && r.vmsTvl) { cb(r.vmsTvl); return; }
    if (window.VMSTvLookup) window.VMSTvLookup.init();
    if (r && r.vmsTvl) { cb(r.vmsTvl); return; }
    if ((tries || 0) < 20) setTimeout(function () { self.widget(cb, (tries || 0) + 1); }, 100);
  };
  Box.prototype.arrive = function (w) {
    var S = window.VMSSavedTv, a = arrival(window.location.search, S && S.get ? S.get() : null, this.data);
    if (!a) { this.el.removeAttribute('data-tvp-reserve'); return; }
    if (a.term) { this.jump = true; w.input.value = a.term; w.lookup(a.term, false, { prefill: true }); return; }
    w.renderRow(a.row, { prefill: true, catalog_version: a.catalog_version });
  };
  Box.prototype.mark = function (tr) {
    this.page.querySelectorAll('tr.is-hit').forEach(function (x) { if (x !== tr) x.classList.remove('is-hit'); });
    if (tr) tr.classList.add('is-hit');
  };
  Box.prototype.selected = function (d) {
    var p = pick(d, this.data), w = this.el.querySelector('[data-vms-tvl]'), card = this.el.querySelector('.vms-tvl__card');
    var go = this.jump, ex = d.explicit === true, S = this.page.vmsTvpSizes;
    this.jump = false;
    if (card && p.href) {
      var a = document.createElement('a'), again = card.querySelector('.vms-tvl__again');
      a.className = 'vms-tvl__find';
      a.href = p.href;
      a.textContent = p.text;
      a.addEventListener('click', function () { if (w && w.vmsTvl) w.vmsTvl.hurry(); });
      card.insertBefore(a, again && again.parentNode === card ? again : null);
    }
    if (p.kind !== 'row') { this.mark(null); return; }
    var code = document.getElementById(p.id), tr = code && code.closest('tr');
    this.mark(tr);
    if (S && p.size != null) { var so = { replace: ex, say: ex, scroll: ex && !go }; if (p.sel) so.sel = p.sel; S.select(p.size, so); }
    if (!code || !(go || (ex && !S))) return;
    code.scrollIntoView({ block: 'start', inline: 'nearest', behavior: motion() });
    var th = tr && tr.querySelector('th');
    if (th && ex) { th.tabIndex = -1; try { th.focus({ preventScroll: true }); } catch (e) { th.focus(); } }
  };

  function motion() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }

  function Sizes(root) {
    var self = this, api = window.VMSTvpSizes;
    this.root = root; this.api = api;
    var c0 = api.chip(root.tvpSizes, root.getAttribute('data-tvp-size'));
    this.cur = c0 ? c0.key : null;
    this.sel = root.tvpSel || null;
    root.querySelectorAll('[data-tvp-chip]').forEach(function (b) {
      b.addEventListener('click', function () { self.select(b.getAttribute('data-tvp-chip') || null, { push: true, say: true }); });
    });
    root.querySelectorAll('[data-tvp-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        var lb = b.getAttribute('data-tvp-lb');
        self.select(b.getAttribute('data-tvp-pick'), { replace: true, say: true, scroll: true, sel: { lb: lb ? Number(lb) : null, find: b.getAttribute('data-tvp-rfind') } });
      });
      var tr = b.closest('tr');
      if (tr) tr.addEventListener('click', function (e) { if (!e.target.closest('a, button')) b.click(); });
    });
    root.querySelectorAll('[data-tvp-more]').forEach(function (b) {
      b.addEventListener('click', function () { self.more(b.getAttribute('data-tvp-more')); });
    });
    window.addEventListener('popstate', function () {
      var rows = {};
      try { rows = JSON.parse(root.querySelector('[data-tvp-data]').textContent).rows || {}; } catch (e) {}
      var k = api.initial(window.location.search, null, root.tvpSizes, rows);
      self.select(k, { say: true, sel: api.sel ? api.sel(window.location.search, null, root.tvpSizes, rows, k) : null });
    });
  }
  // z is a chip key (sizes_json.chips[].key: the size, or "<size>-<year>"); o.sel = the selected row's lb and find.
  Sizes.prototype.select = function (z, o) {
    o = o || {};
    var api = this.api, root = this.root, data = root.tvpSizes, c = api.chip(data, z);
    z = c ? c.key : null;
    if (z !== this.cur) root.tvpOpen = {};
    this.sel = c && o.sel ? o.sel : null;
    var t = api.apply(root, z, root.tvpOpen, this.sel);
    this.cur = z;
    if ((o.push || o.replace) && window.history && window.URL) {
      var u = new URL(window.location.href);
      if (z != null) u.searchParams.set('size', String(z)); else u.searchParams.delete('size');
      if (u.href !== window.location.href) window.history[o.push ? 'pushState' : 'replaceState'](null, '', u.href);
    }
    var st = root.querySelector('[data-tvp-status]');
    if (o.say && st) st.textContent = api.T.say(t.wall || 0, t.ceiling || 0, c ? c.size : null, data.d);
    if (o.scroll) {
      var f = root.querySelector('[data-tvp-filter]'), h = root.querySelector('[data-tvp-g] .vms-tvp__h2');
      if (f) f.scrollIntoView({ block: 'start', behavior: motion() });
      if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
    }
    return t;
  };
  Sizes.prototype.more = function (g) {
    var root = this.root, sec = root.querySelector('[data-tvp-g="' + g + '"]');
    if (!sec) return;
    var was = Array.prototype.filter.call(sec.querySelectorAll('[data-tvp-fit]'), function (li) { return li.hidden; });
    root.tvpOpen = root.tvpOpen || {};
    root.tvpOpen[g] = true;
    this.api.apply(root, this.cur, root.tvpOpen, this.sel);
    for (var i = 0; i < was.length; i++) {
      if (!was[i].hidden) { var a = was[i].querySelector('a[href]') || was[i]; if (a === was[i]) was[i].tabIndex = -1; a.focus(); break; }
    }
  };

  function init() {
    if (!root.document || !root.document.querySelectorAll) return;
    root.document.querySelectorAll('[data-vms-tvp="series"]').forEach(function (el) { if (!el.vmsTvpSizes && el.tvpSizes && root.VMSTvpSizes) el.vmsTvpSizes = new Sizes(el); });
    root.document.querySelectorAll('[data-tvp-look]').forEach(function (el) { if (!el.vmsTvp) el.vmsTvp = new Box(el); });
  }
  root.VMSTvPages = { norm: norm, pick: pick, arrival: arrival, findHref: findHref, reserveOn: reserveOn, init: init };
  if (!root.document) return;
  if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', init); else init();
  root.document.addEventListener('shopify:section:load', init);
})(window);
